var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosMondayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33835 21.6458C3.57365 21.6476 2.82222 21.4374 2.16082 21.0368C1.49942 20.6363 0.951748 20.0596 0.573755 19.3659C0.201542 18.677 0.0159068 17.8954 0.0367346 17.1048C0.0575625 16.3143 0.284068 15.5445 0.691989 14.878L8.44454 2.17216C8.84134 1.48932 9.4047 0.928632 10.0771 0.547369C10.7494 0.166105 11.5067 -0.0220708 12.2716 0.00206068C13.0358 0.0211826 13.7815 0.251883 14.4323 0.670552C15.0831 1.08922 15.6156 1.68083 15.9753 2.38483C16.6981 3.81102 16.6077 5.52688 15.7423 6.86578L7.99457 19.5715C7.60168 20.2105 7.06059 20.7356 6.42145 21.0982C5.78232 21.4608 5.06581 21.6492 4.33835 21.6458Z",
    fill: "#F62B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6372 21.645C16.0735 21.645 14.6347 20.7725 13.8791 19.3703C13.5077 18.6833 13.3225 17.9037 13.3434 17.1153C13.3642 16.3268 13.5903 15.5591 13.9973 14.8945L21.7351 2.21773C22.1261 1.52529 22.6875 0.954639 23.361 0.564947C24.0346 0.175255 24.7957 -0.0192837 25.5655 0.00150796C27.1423 0.0374695 28.5713 0.957944 29.2939 2.39796C29.6466 3.10309 29.8071 3.89573 29.7579 4.68949C29.7086 5.48326 29.4516 6.24769 29.0148 6.8995L21.2786 19.5761C20.8869 20.2124 20.348 20.7354 19.7116 21.097C19.0752 21.4586 18.3618 21.6471 17.6372 21.6451V21.645Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6359 21.7521C32.8402 21.7521 34.6272 19.9262 34.6272 17.6739C34.6272 15.4216 32.8402 13.5957 30.6359 13.5957C28.4315 13.5957 26.6445 15.4216 26.6445 17.6739C26.6445 19.9262 28.4315 21.7521 30.6359 21.7521Z",
    fill: "#00CA72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5921,
    height: 22,
    fill: "white",
    transform: "translate(0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosMondayIcon);
export default __webpack_public_path__ + "static/media/logos_monday-icon.a09f132834b721edec51ff42cf822a4d.svg";
export { ForwardRef as ReactComponent };